import * as React from 'react';
import { cn } from '../utils/tailwind-merge';

interface NotificationBadgeProps extends React.HTMLAttributes<HTMLDivElement> {}

const NotificationBadge = React.forwardRef<HTMLDivElement, NotificationBadgeProps>(
  ({ className, children, ...props }) => {
    return (
      <div className={cn('rounded-xl bg-red-11', className)} {...props}>
        {children}
      </div>
    );
  },
);

export default NotificationBadge;
